
import Order from "@/models/Order";
import Product from "@/models/Product";
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import InitLoader from "@/components/UI/Loader/InitLoader.vue";
import OrderReplacementItem from "./OrderReplacementItem.vue";
import UIButton from "@/components/UI/Button/UIButton.vue";
import CloseIcon from "@/components/UI/Icons/CloseIcon.vue";
import { _axios } from "@/apiManager/_requestHelper";



export default Vue.extend({
  components: {
    "init-loader": InitLoader,
    "order-replacement-item": OrderReplacementItem,
    "ui-button": UIButton,
    "close-icon": CloseIcon,
  },
    data: () => ({
        itemsToManipulate: [] as Product[],
        currentSelectedItem: {} as Product,
        currentSelectedReplacement: {} as Product,
        loading: false as boolean,
        replacementDialog: false as boolean,
        alternativesLoading: false as boolean,
        replacementsObject: [] as any[],
        countdown: 0 as number,
        countdownInterval: null as ReturnType<typeof setInterval> | null,
        showExtendTimePopup: false as boolean,
        submitted: false as boolean,
        currentSelectedReplacementQuantity: 0 as number
    }),

  computed: {
    ...mapState("order", ["singleOrder"]),
    ...mapState("loading", ["singleOrderLoading"]),
    ...mapState("partner", ["partnerSettings"]),

    orderDetails(): Order {
      return (this as any).singleOrder as Order;
    },


    submitButtonLabel() {
      var removedCount = 0;
      var toBeReplacedCount = 0;

      for (const item of this.itemsToManipulate) {
        if (this.getItemStatus(item) == 1 ) {
          removedCount++;
        } else {
          toBeReplacedCount++
        }
      }
      return `${removedCount} Removed  |  ${toBeReplacedCount} To be Replaced`;
    },
    allHandled(): boolean {
      for (var item of this.itemsToManipulate) {
        if (this.getItemStatus(item) !== 1 && this.getItemStatus(item) !== 3 && this.getItemStatus(item) !== 4) {
          return false;
        }

      } return true;
      
    },
  },

  methods: {
    ...mapActions("order", ["singleOrderById", "placeAlternativeOrderRequest"]),

    // get order details
    // order id is taken from the route
    async getOrderDetails() {
      this.loading = true;
      var orderId = this.$route.params["orderId"];

      await this.singleOrderById({
        id: orderId,
        includeAlternatives: true,
      });

      // get the oos items to manipulate
      if ( this.orderDetails != null && this.orderDetails.items != null && this.orderDetails.items.length > 0) {
        this.itemsToManipulate = this.orderDetails.items.filter((i) => !i.isAlreadyCollected && i.isPurchasedItemOutOfStock);
        this.sort();

       this.itemsToManipulate.forEach((i) => {
          if(i.alternativeItems != null) {
            i.alternativeItems = i.alternativeItems.sort((a, b) => {
              return Number(a.id !== i.id) - Number(b.id !== i.id);
            });
          }
        });

      }

      const maxTime = this.orderDetails.maxWaitingMinutesForAlternatives;
      if (maxTime) {
          this.countdown = maxTime * 60;
          (this as any).startCountdown();
      }

      this.loading = false;
    },

    // set current item and open dialog
    selectItemReplacement(item: Product) {
      this.currentSelectedItem = item;
      var itemFound = this.replacementsObject.find((i: any) => i.oosItem.id == this.currentSelectedItem.id);

      if(itemFound != null) {
        if(itemFound.replacementItem != null) {
          this.currentSelectedReplacement = itemFound.replacementItem;
          this.currentSelectedReplacementQuantity = itemFound.quantity;
        }

        else {
          this.currentSelectedReplacement = {} as Product;
        }
      }

      else {
        this.currentSelectedReplacement = {} as Product;
      }

      this.replacementDialog = true;
      
    },

    selectAlternative(quantity: number, replacement?: Product) {
      var now = Date();

      var itemFound = this.replacementsObject.find((i: any) => i.oosItem.id == this.currentSelectedItem.id);
      if (itemFound != null) {
        itemFound.replacementItem = replacement;
        itemFound.quantity = quantity;
        itemFound.updated = now;
        
        this.$forceUpdate();
      } 
      else {
        
        this.replacementsObject.push({
          oosItem: this.currentSelectedItem,
          replacementItem: replacement == null ? null : replacement,
          quantity: quantity,
          updated: now
        });
      }
      this.sort();
      this.sortByTime();
      this.replacementDialog = false;
      this.currentSelectedItem = {} as Product;
      this.currentSelectedReplacement = {} as Product;
      this.currentSelectedReplacementQuantity = 0;

    },

    // sort items list
    sort() {
      // First, create a Set of replacement item IDs for fast lookup
      const replacementItemIds = new Set(this.replacementsObject.map((obj: any) => obj.replacementItem != null && obj.replacementItem.id));

      // Then sort the products list
      this.itemsToManipulate.sort((a, b) => {
        const aHasReplacement = replacementItemIds.has(a.id);
        const bHasReplacement = replacementItemIds.has(b.id);
       
        // Step 3: prioritize isEmployeeForceDiscarded === false
        if (a.isEmployeeForceDiscarded !== b.isEmployeeForceDiscarded) {
          return ( Number(a.isEmployeeForceDiscarded) - Number(b.isEmployeeForceDiscarded));
        }
        
        // Step 4: prioritize items that does not contains replacements
        if (!a.hasAlternatives !== !b.hasAlternatives) {
          return Number(!a.hasAlternatives) - Number(!b.hasAlternatives);
        }

        // Items without replacements (false) come before (true)
        return Number(aHasReplacement) - Number(bHasReplacement);
      });
    },

    sortByTime() {
      // Create a Set for quick lookup of replacement item IDs
      const replacementItemIds = new Set(
        this.replacementsObject
          .filter((obj: any) => obj.oosItem != null)
          .map((obj: any) => obj.oosItem.id)
      );

      this.itemsToManipulate.sort((a, b) => {
        const aHasReplacement = replacementItemIds.has(a.id);
        const bHasReplacement = replacementItemIds.has(b.id);

        // First sort by whether the item has a replacement: no replacement (false) should come first
        if (aHasReplacement !== bHasReplacement) {
          return Number(aHasReplacement) - Number(bHasReplacement);
        }

        // Both have or both don't have replacements
        // If both have replacements, sort by replacement update time (oldest first)
        if (aHasReplacement && bHasReplacement) {
          const replacementOfA = this.replacementsObject.find((i: any) => i.oosItem.id === a.id);
          const replacementOfB = this.replacementsObject.find((i: any) => i.oosItem.id === b.id);

          const dateA = new Date(replacementOfA.updated);
          const dateB = new Date(replacementOfB.updated);

          return dateA.getTime() - dateB.getTime(); // older first, newer later
        }

        // If both don't have replacements, maintain original order (or sort alphabetically/etc.)
        return 0;
      });
    },

   
    // submit alternatives request
    async submitAlternatives() {
      this.alternativesLoading = true;
      var payload = {
        id: this.$route.params["orderId"],
        items: this.replacementsObject.map((r: any) => {
          return {
            oosOrderItemId: r.oosItem.orderItemId,
            replacementInvId: r.replacementItem != null ? r.replacementItem.id : null,
            replacementQuantity: r.quantity,
          };
        }),
      };
      await this.placeAlternativeOrderRequest(payload)
        .then(() => {
          this.alternativesLoading = false;
        })
        .catch(() => {
          this.alternativesLoading = false;
        });
      this.submitted= true;
    },

    // get item replacement status
    getItemStatus(item: Product): number {
        
        if(!item.hasAlternatives || item.isEmployeeForceDiscarded)
            return 1;

        if (this.replacementsObject != null && this.replacementsObject.length > 0) {
            var replacementFound = this.replacementsObject.find((x) => x.oosItem.id == item.id);

            if (replacementFound == null) 
              return 2;

            if (typeof replacementFound == "undefined" || replacementFound.replacementItem == null || replacementFound.replacementItem.id == "undefined" || replacementFound.replacementItem.id == 0 )
              return 3;

            return 4;
        }

        return 0;
    },

    getItemSelectedReplacement(item: Product): Product | null {
      if (this.replacementsObject != null && this.replacementsObject.length > 0) {
        var replacementFound = this.replacementsObject.find(
          (x) => x.oosItem.id == item.id
        );

        if ( replacementFound != null && replacementFound.replacementItem != null) {
          replacementFound.replacementItem.purchasedQuantity = replacementFound.quantity;
          return replacementFound.replacementItem;
        }
      }

      return null;
    },

    // set timer
    // countdown timer
    startCountdown() {
      if (this.countdownInterval) clearInterval(this.countdownInterval);

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;

          // At 5 minutes left
          if (this.countdown === 300) {
            this.showExtendTimePopup = true;
          }
        }

        if (this.countdown === 0) {
          clearInterval(this.countdownInterval!);
          this.countdownInterval = null;
          // this.handleTimerEnd();
        }
      }, 1000);
    },
    
      continueWithoutExtension() {
          this.showExtendTimePopup = false;
      },

      removeSelectedReplacement() {
          this.$nextTick(() => {
              this.currentSelectedReplacement = {} as Product;
          })
      },

      goToStoreHomePge() {
        this.$router.push({name: "StoreHomePageDeepLink"})
      }
    },


  async mounted() {
    await this.getOrderDetails();

    var token = this.$route.query["token"];
    if(typeof token != "undefined" && token != null)
        _axios.defaults.headers.common["Authorization"] = "Bearer " + this.$route.query["token"];
  },
});
